module.exports = __webpack_public_path__ + "static/media/gallery-2-12.b9c5ae70.jpg";